// extracted by mini-css-extract-plugin
export default {"wrappNotes":"dealNotes_wrappNotes__z3ZgG"};